import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  ADMIN: {
    UPLOAD_EXTERNAL_CPD: (externalCpds) => ({ externalCpds }),
    API: {
      UPLOAD_EXTERNAL_CPD: apiResourceActionCreator('externalCpd')
    }
  }
})

export const apiAction = (authToken, externalCpds) => commonApiActions.authenticated.post(`${API_ENDPOINT}/uploadExternalCpd`, authToken, externalCpds, actions.admin.api.uploadExternalCpd);

function* uploadExternalCpd(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload.externalCpds));
}

const configuration = {
  name: 'uploadExternalCpd',
  action: actions,
  sagas: uploadExternalCpd,
  reducers: {
    request: (state, action) => ({
      ...state,
      isUploadingCPD: true
    }),
    success: (state, action) => ({
      ...state,
      isUploadingCPD: false,
      externalCpdUploadResult: action.payload.externalCpd
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      isUploadingCPD: false,
      externalCpdUploadResult: []
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/uploadExternalCpd.js